export const MenuItemsEvent = [
    {
      title: 'Our Events',
      path: '/events',
      cName: 'dropdown-link'
    },
    {
      title: 'Collaborations',
      path: '/collaborations',
      cName: 'dropdown-link'
    },
  ];
  